import React from 'react';

import CleanBanner from '@/components/corporate/CleanBanner';
import Seo from '@/components/seo/Seo';
import { ROUTE_SEO } from '@/config/seo';
import { histories, History as HistoryItem } from '../../components/data/Histories';

// 플랫 연혁 데이터를 연도별 그룹으로 묶는다(원본은 최신→과거 순으로 정렬되어 있음).
interface YearGroup {
  year: string;
  entries: HistoryItem[];
}

function groupByYear(items: HistoryItem[]): YearGroup[] {
  const groups: YearGroup[] = [];
  items.forEach((item) => {
    let group = groups.find((g) => g.year === item.year);
    if (!group) {
      group = { year: item.year, entries: [] };
      groups.push(group);
    }
    group.entries.push(item);
  });
  return groups;
}

const History: React.FC = () => {
  const years = groupByYear(histories);

  return (
    <div className="cp">
      <Seo
        title={ROUTE_SEO.histories.title}
        description={ROUTE_SEO.histories.description}
        path={ROUTE_SEO.histories.path}
      />
      <CleanBanner eyebrow="HISTORY" title="주요 연혁" desc="데이터로 공공을 혁신해 온 프람트테크놀로지의 발자취" />

      <section className="cp-section">
        <div className="cp-timeline">
          {years.map((y) => (
            <div key={y.year} className="cp-timeline__group">
              <div>
                <div className="cp-timeline__year">{y.year}</div>
              </div>
              <div className="cp-timeline__spine">
                {y.entries.map((e, idx) => (
                  <div key={idx} className="cp-timeline__entry">
                    <span className="cp-timeline__dot" />
                    <div className="cp-timeline__month">{e.month}</div>
                    <div className="cp-timeline__content" dangerouslySetInnerHTML={{ __html: e.content }} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default History;
